// Curso de Formación Pastoral FRUTO (8h) — el retiro presencial sigue siendo el evento real
// (Doc 03/06 de Phil: 4 sesiones grupales, inventario, debrief entre pares — eso no se
// digitaliza). Estos 6 módulos son andamiaje digital: preparan al pastor antes del retiro y le
// dan algo a lo que volver entre sesiones. No son el criterio de tránsito de estadio.
// verificationMode: "mentor" se mantiene sin cambio — el avance real entre Raíz/Tronco/Ramas
// sigue siendo stageApprovals en enrollments, aprobado por el mentor en conversación, nunca por
// completar estas lecciones. Ver project-log/sesiones/S09-corpus-fruto.md para el mapeo
// contenido↔fuente y la decisión de alcance.
export default {
  id: "fruto-pastoral-8h",
  type: "mentor_verified",
  verificationMode: "mentor",
  titleKey: "programs.fruto_pastoral.title",
  descriptionKey: "programs.fruto_pastoral.desc",
  modules: [
    {
      id: "mod1",
      titleKey: "programs.fruto_pastoral.mod1.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod1.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod1.les1.text1" },
            {
              type: "verse",
              reference: "James 1:22-24",
              referenceKey: "programs.fruto_pastoral.mod1.les1.reference1",
              textKey: "programs.fruto_pastoral.mod1.les1.verse1",
            },
          ],
          questions: [
            { id: "m1-q1", type: "reflection", promptKey: "programs.fruto_pastoral.mod1.les1.q1" },
          ],
        },
      ],
    },
    {
      id: "mod2",
      titleKey: "programs.fruto_pastoral.mod2.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod2.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod2.les1.text1" },
            {
              type: "verse",
              reference: "1 Peter 5:2-3",
              referenceKey: "programs.fruto_pastoral.mod2.les1.reference1",
              textKey: "programs.fruto_pastoral.mod2.les1.verse1",
            },
          ],
          questions: [
            { id: "m2-q1", type: "reflection", promptKey: "programs.fruto_pastoral.mod2.les1.q1" },
          ],
        },
      ],
    },
    {
      id: "mod3",
      titleKey: "programs.fruto_pastoral.mod3.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod3.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod3.les1.text1" },
          ],
          questions: [
            { id: "m3-q1", type: "reflection", promptKey: "programs.fruto_pastoral.mod3.les1.q1" },
          ],
        },
      ],
    },
    {
      id: "mod4",
      titleKey: "programs.fruto_pastoral.mod4.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod4.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod4.les1.text1" },
            {
              type: "verse",
              reference: "Ephesians 4:11-12",
              referenceKey: "programs.fruto_pastoral.mod4.les1.reference1",
              textKey: "programs.fruto_pastoral.mod4.les1.verse1",
            },
          ],
          questions: [
            { id: "m4-q1", type: "reflection", promptKey: "programs.fruto_pastoral.mod4.les1.q1" },
          ],
        },
      ],
    },
    {
      id: "mod5",
      titleKey: "programs.fruto_pastoral.mod5.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod5.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod5.les1.text1" },
            {
              type: "verse",
              reference: "Galatians 4:19",
              referenceKey: "programs.fruto_pastoral.mod5.les1.reference1",
              textKey: "programs.fruto_pastoral.mod5.les1.verse1",
            },
          ],
          questions: [
            { id: "m5-q1", type: "reflection", promptKey: "programs.fruto_pastoral.mod5.les1.q1" },
          ],
        },
      ],
    },
    {
      id: "mod6",
      titleKey: "programs.fruto_pastoral.mod6.title",
      lessons: [
        {
          id: "les1",
          titleKey: "programs.fruto_pastoral.mod6.les1.title",
          contentBlocks: [
            { type: "text", textKey: "programs.fruto_pastoral.mod6.les1.text1" },
            {
              type: "verse",
              reference: "Luke 16:10",
              referenceKey: "programs.fruto_pastoral.mod6.les1.reference1",
              textKey: "programs.fruto_pastoral.mod6.les1.verse1",
            },
          ],
          questions: [
            { id: "m6-q1", type: "application", promptKey: "programs.fruto_pastoral.mod6.les1.q1" },
          ],
        },
      ],
    },
  ],
};
